/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assignment_Choose_One_ProjectInputs */

const fr_assignment_choose_one_project = /** @type {(inputs: Assignment_Choose_One_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez au moins un projet à affecter.`)
};

const en_assignment_choose_one_project = /** @type {(inputs: Assignment_Choose_One_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose at least one project to assign.`)
};

/**
* | output |
* | --- |
* | "Choose at least one project to assign." |
*
* @param {Assignment_Choose_One_ProjectInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const assignment_choose_one_project = /** @type {((inputs?: Assignment_Choose_One_ProjectInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assignment_Choose_One_ProjectInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_assignment_choose_one_project(inputs)
	return fr_assignment_choose_one_project(inputs)
});